import React from 'react';
import DeviceId from '../flows/DeviceId';
import { getCsrfToken } from '../helpers/GetCsrfToken';
import { logClientEvent } from '../helpers/ClientLog';

const braintree = require('braintree-web');

export default class PayByVault extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethods: null,
      vaultManagerInstance: null
    };
  }

  getVaultManagerCards() {
    braintree.vaultManager
      .create({
        authorization: this.props.clientToken,
        paymentMethods: null
      })
      .then(vaultManagerInstance => {
        this.setState({ vaultManagerInstance });
        vaultManagerInstance.fetchPaymentMethods((err, paymentMethods) => {
          this.setState({ paymentMethods });
        });
      });
  }

  openCancelCardModal(index) {

    const deleteCardCallback = () => this.deleteCard(index);
    this.props.setMainModalCTA(deleteCardCallback);

    const title = 'Delete card?';
    const message = 'Are you sure you want to proceed?';
    const mainCTAText = 'Yes';
    const secondaryCTAText = 'No';
    this.props.setupMainModal({ title, message, mainCTAText, secondaryCTAText });
    this.props.enableMainModal();
  }

  openUseSavedCardModal(payload) {
    const payWithCardCallback = payload => {
      this.payWithPayload(payload);
    };
    this.props.setMainModalCTA(() => payWithCardCallback(payload));

    const title = 'Pay using this card?';
    const message = 'Confirm that you will use this card to pay';
    const mainCTAText = 'Pay';
    const secondaryCTAText = 'Cancel';
    this.props.setupMainModal({ title, message, mainCTAText, secondaryCTAText });
    this.props.enableMainModal();
  }

  componentDidMount() {
    this.getVaultManagerCards();
  }

  async postPayment(payload, hostedFieldsInstance) {
    const response = await fetch(`api/Braintree/Pay`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken(),
        'DEVICE_ID': DeviceId.DEVICE_ID
      },
      body: this.props.generatePaymentBody(payload)
    })
    let data;
    try {
      data = await response.json();
    } catch (err) {
      console.error(err)
      this.props.submitPaymentFail();
    }
    if (data.success === true) {
      this.state.vaultManagerInstance.teardown(function (teardownErr) {
        if (teardownErr) console.error('Could not tear down the Hosted Fields form!');
      });
      this.props.paymentSuccessful(data);
    } else {
      this.props.submitPaymentFail(data.reason);
    }
  }

  payWithPayload(payload) {
    this.props.submitPayment();
    logClientEvent('Payment submitted', { PaymentMethod: 'VaultedCard' });

    var threeDSecureParameters = {
      amount: this.props.grandTotal,
      nonce: payload.nonce,
      bin: payload.details.bin,
      email: this.props.customer
        ? this.props.customer.emailAddress
        : null,
      onLookupComplete: (data, next) => {
        // use `data` here, then call `next()`
        next();
      }
    };

    let threeDSecure;

    braintree.client
      .create({
        authorization: this.props.clientToken
      })
      .then(clientInstance => {
        return braintree.threeDSecure.create({
          version: '2-inline-iframe', // Will use 3DS 2 whenever possible
          client: clientInstance
        });
      })
      .then(threeDSecureInstance => {
        threeDSecure = threeDSecureInstance;
        const payByCardContainer = document.getElementById(
          'pay-by-card-container'
        );
        threeDSecure.on('authentication-iframe-available', (event, next) => {
          this.props.pausePaymentLoadingAnimation();
          payByCardContainer.appendChild(event.element);
          event.element.className = 'three-d-secure-container';
          next();
        });
        threeDSecure
          .verifyCard(threeDSecureParameters)
          .then(async response => {
            this.props.unpausePaymentLoadingAnimation();
            threeDSecure.teardown();
            var threeDSecureElem = document.getElementsByClassName(
              'three-d-secure-container'
            )[0];
            if (!!threeDSecureElem) {
              payByCardContainer.removeChild(threeDSecureElem);
            }
            await this.postPayment(response, threeDSecureInstance);
          })
          .catch(error => {
            console.log(error);
            this.props.unpausePaymentLoadingAnimation();
            threeDSecure.teardown();
            var threeDSecureElem = document.getElementsByClassName(
              'three-d-secure-container'
            )[0];
            if (!!threeDSecureElem) {
              payByCardContainer.removeChild(threeDSecureElem);
            }
            this.props.submitPaymentFail();
            // Handle error
          });
      })
      .catch(err => {
        console.log(err);
        this.props.submitPaymentFail();
        // Handle component creation error
      });
  }

  deleteCard(index) {

    fetch('api/Braintree/RemoveVaultedCard', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken(),
        'DEVICE_ID': DeviceId.DEVICE_ID
      },
      body: JSON.stringify({
        Index: index,
        VaultId: !!this.props.customer && this.props.customer.vaultId,
        CustomerId: !!this.props.customer && this.props.customer.id,
        RestaurantId: this.props.restaurant.id
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success === true) {
          this.getVaultManagerCards();
        } else {
          // ?
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {

    const paymentMethods =
      this.state.paymentMethods &&
      this.state.paymentMethods.map((paymentMethod, index) => {
        return (
          <div className="vaulted-card" key={index}>
            {/* <div key={`c ${index}`} className="btn btn-primary btn-saved-card card" onClick={() => this.payWithPayload(paymentMethod.nonce)}>{paymentMethod.details.cardType} ****{paymentMethod.details.lastFour}</div> */}
            <div
              key={`c ${index}`}
              className="btn btn-primary btn-saved-card card"
              onClick={() => this.openUseSavedCardModal(paymentMethod, index)}
            >
              {paymentMethod.details.cardType} ****
              {paymentMethod.details.lastFour}
            </div>
            {/* <div key={`d ${index}`} className="btn btn-secondary btn-saved-card delete" onClick={() => { this.deleteCard(index) }}>X</div> */}
            <div
              key={`d ${index}`}
              className="btn btn-secondary btn-saved-card delete"
              onClick={() => this.openCancelCardModal(index)}
            >
              X
            </div>
          </div>
        );
      });
    if (!!paymentMethods && paymentMethods.length > 0) {
      return (
        <div className="vaulted-cards">
          <h3 className="title">Saved Cards</h3>
          {paymentMethods}
        </div>
      );
    } else {
      return null;
    }
  }
}
